import React, { useCallback, useEffect, useState } from 'react';
import { ClearButton, Container, InputWrapper, RangeInput, Select, VisualContainer } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';


interface ValueType{
    start?: string|number|undefined,
    end?: string|number|undefined,
    option?: string|number|undefined
}
interface AppYarRangeProps {
    condSecondInput: (option: {key: string, value: string}) => boolean;
    options: {key: string; value: string}[]
    onChange: (value: ValueType) => void
    value: ValueType
}

const AppYearRange: React.FC<AppYarRangeProps> = ({ options, condSecondInput, onChange, value}) => {
    const [option, setOption] = useState<string|number|undefined>()
    const [showSecondInput, setShowSecondInput] = useState<boolean>(false);
    const [input, setInput] = useState<string|undefined|number>();
    const [input2, setInput2] = useState<string|undefined|number>();

    useEffect(() => {
        if(value && value.option){
            const selected = options.find(x => x.key === value.option);
            if(selected){
                setShowSecondInput(condSecondInput(selected))
            }
        }
    }, [value]);

    const handleChangeOption = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
        const  { value: selectedOption } = e.target;
        const selected = options.find(x => x.key === selectedOption);
        if(selected){
            onChange({
                ...value,
                option: selected?.key
            })
            setShowSecondInput(condSecondInput(selected))
        }
    }, [options, onChange, value])

    return (
        <Container>
            <InputWrapper $isDouble={showSecondInput}>
                <RangeInput
                    type="number"
                    maxLength={4}
                    min={1000}
                    max={9999}
                    value={value.start || ''}
                    onChange={e => onChange({
                        ...value,
                        start: e.target.value
                    })} />
            </InputWrapper>
            <Select
                value={value.option || ''}
                onChange={handleChangeOption}>
                {
                    options.map(({key, value}, i: number) => (
                        <option value={key} key={key}>{value}</option>
                    ))
                }
            </Select>
            {showSecondInput && (
                <InputWrapper $isDouble={showSecondInput}>
                    <RangeInput
                        type="number"
                        maxLength={4}
                        min={1000}
                        max={9999}
                        value={value.end || ''}
                        onChange={e => onChange({
                            ...value,
                            end: e.target.value
                        })} />
                </InputWrapper>
            )}
            {
                value.start || value.end ? (
                    <ClearButton onClick={() => {
                        onChange({
                            start: undefined,
                            end: undefined,
                            option: '='
                        })
                    }}>
                        <FontAwesomeIcon icon={faTimes as IconProp} />
                    </ClearButton>
                ) : ''
            }

            <VisualContainer />
        </Container>
    )
}

export default  AppYearRange
